<template>
    <div id="main" class="row">
        <fieldset>
            <legend>Itens de formação</legend>
            <div class="row">
                <center>
                    <span>{{ title }} </span>
                </center>
            </div>

            <div
                class="input-field col s6 m6 l6 xl6"
                v-for="(option, index) in options"
                :key="index"
            >
                <br />
                <select
                    class="browser-default select_sec"
                    :id="'select' + option.id"
                    v-if="itens && itens[index]"
                    v-model="itens[index].valor"
                    @change="changeItem($event, option)"
                >
					<option disabled selected value=''>Selecione uma opção</option>

                    <option
                        v-for="(valor, i) in Object.keys(option.valores)"
                        :key="i"
                        :value="option.valores[valor]"
                    >
                        {{ valor }}
                    </option>
                </select>

                <label
                    :id="'label' + option.id"
                    :name="option.nome"
                    class="active"
                    >{{ option.nome }}</label
                >
            </div>
            <div class="row">
                <div class="col s12">
                    <h5>
                        Nota:
                        <span>
                            {{ nota }}
                        </span>
                    </h5>
                </div>
            </div>
        </fieldset>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
    name: "AvaliacaoCurriculoItemFormacao",
    data() {
        return {
            nota: 0,
            notaMax: 0
        };
    },
    asyncComputed: {
        async title() {
            try {
                let { data } = await this.$http.get("/api/mensagens/12");
                return data.mensagem;
            } catch (error) {
                console.log(error);
            }
        },
        async options() {
            try {
                let { data } = await this.$http.get(
                    "/api/avaliacaoCurriculo/formacao"
                );
                return data;
            } catch (error) {
                console.log(error);
            }
        }
    },
    watch: {
        options(newValue, oldValue) {
            if (newValue) {
                this.hasItens();
            }
        }
    },
    computed: {
        ...mapState(["project"]),
        itens: {
            get() {
                try {
                    return this.project.avaliacao.avaliacao_curriculo
                        .item_formacao;
                } catch (error) {
                    console.log(error);
                }
            }
        }
    },
    methods: {
        ...mapActions({ setItemFormacao: "setAvaliacaoCurriculoItemFormacao" }),
        async getNotaMax() {
            try {
                let { data } = await this.$http.get("/api/nova_avaliacao/notaMax/6");
                return data[0].nota_max;
            } catch (error) {
                console.log(error);
            }
        },
        sum() {
            if (this.itens && this.itens.length && this.notaMax != 0) {
                let total = this.itens
                    .map(e => e.valor)
                    .reduce(
                        (acc, currentValue) =>
                            Number(acc) + Number(currentValue)
                    );
                if (Number(total) > Number(this.notaMax))
                    total = Number(this.notaMax);
                this.$set(this, "nota", total);
            }
            return true;
        },
        changeItem(event, option) {
            let values = Object.values(option.valores);
            let keys = Object.keys(option.valores);
            let index = values.findIndex(e => e == event.target.value);
            let item = this.itens.find(e => e.id == option.id);
            item.option = keys[index];
            this.sum();
            this.$set(this.itens, "nota", this.nota);
            this.$emit("add-item", this.itens);
        },
        hasItens() {
            if (!this.itens || !this.itens.length || this.itens.length == 0) {
                this.options.forEach((e, i) => {
                    let obj = {
                        id: e.id,
                        nome: e.nome,
                        option: "",
                        valor: ''
                    };
                    this.itens.push(obj);
                });
            }
        }
    },
    created() {
        try {
            this.getNotaMax().then(notaMax => {
                this.$set(this, "notaMax", notaMax);
                this.sum();
            });
        } catch (error) {
            console.log(error);
        }
    }
};
</script>
